React = require 'react'
t = require('views/internal/recup-with-helpers')('home')
l = require 'lib/localize'
Auth = require 'db/auth'
Dates = require 'lib/dates'
HomeSectionHeaderComponent = require 'views/home/home-section-header-component'
HomeUpNextCardComponent = require 'views/home/home-up-next-card-component'
HomeOrientationComponent = require 'views/home/home-orientation-component'

module.exports = class HomeUpNextComponent extends React.Component
  displayName: 'HomeUpNextComponent'

  constructor: (props) ->
    @state = {
      numUpNextCardsVisible: 1
    }

    @onShowMoreClick = @onShowMoreClick.bind(@)

  onShowMoreClick: ->
    @setState (prevState, props) ->
      numUpNextCardsVisible: prevState.numUpNextCardsVisible + 6

  render: t.renderable ->
    {
      upNextCards
      optimisticallyDismissedCardIds
      optimisticallyDismissCard
      dismissCard
      dismissUpNextOrientationCard
      modelCache
    } = @props

    { numUpNextCardsVisible } = @state

    upNextCards = upNextCards.filter (upNext) -> !optimisticallyDismissedCardIds[upNext.card.id]

    if upNextCards.length
      t.div '.up-next-cards.home-main-content-item',
        ref: (el) -> Dates.update(el)
      , =>
        t.addElement React.createElement HomeSectionHeaderComponent, {
          title: l('home title.up next')
          iconClass: 'checkbox-checked'
        }

        if !Auth.me().isDismissed('homeUpNextOrientationCard')
          t.addElement React.createElement HomeOrientationComponent, {
            title: 'orientation-up-next-title'
            text: 'orientation-up-next-text'
            backgroundClass: 'home-orientation-up-next-background'
            onDismissClick: dismissUpNextOrientationCard
          }

        t.ul '.up-next-card-list', =>
          upNextCards.map (upNextCard, index) =>
            if index < numUpNextCardsVisible
              t.addElement React.createElement HomeUpNextCardComponent, {
                key: upNextCard.id
                upNextId: upNextCard.id
                card: upNextCard.card
                board: upNextCard.board
                org: upNextCard.org
                list: upNextCard.list
                item: upNextCard.item
                modelCache
                dismissCard
                optimisticallyDismissCard
              }

          if upNextCards.length > numUpNextCardsVisible
            t.a '.show-more.u-text-align-center', { onClick: @onShowMoreClick }, ->
              t.format 'show-more'

    else
      t.div()



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-up-next-component.coffee